module.exports = __webpack_public_path__ + "img/test-1-4-4.22718c55.png";